// REPLACE your Cover.jsx with this version:

import React from 'react';
import PrintSafeImage from '../PrintSafeImage';

export default function Cover({ items = [], meta, tripName, isPrinting }) {
  const first = items?.[0];
  const title = meta?.title || tripName || 'Trip Title';
  const subtitle = meta?.subtitle || meta?.dateRange || 'Date Range';

  // Apply position data if it exists
  const position = first?.position || { x: 50, y: 50, scale: 100 };
  
  const photoStyle = isPrinting ? {
  // PDF-safe styles
  position: 'absolute',
  width: '100%',
  height: 'auto',
  minWidth: '100%',
  minHeight: '100%',
  top: '50%',
  left: '50%',
  filter: 'brightness(.9)',
  transform: `translate(-50%, -50%) scale(${position.scale / 100}) translateX(${position.x - 50}%) translateY(${position.y - 50}%)`,
} : {
  // LIVE PREVIEW styles (reverted to object-fit)
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  filter: 'brightness(.9)',
  objectPosition: `${position.x}% ${position.y}%`,
  transform: `scale(${position.scale / 100})`,
  transformOrigin: `${position.x}% ${position.y}%`,
};

  return (
    <div style={{ position:'relative', width:'100%', height:'100%', overflow:'hidden' }}>
      <div style={{ position:'absolute', inset:0, background:'#ddd' }}>
        {first?.url ? (
          <PrintSafeImage 
  src={first.url} 
  alt="" 
  style={photoStyle} 
  position={position} 
  isPrinting={isPrinting} 
/>
        ) : null}
      </div>
      <div style={{ position:'absolute', left:'10%', bottom:'12%', color:'#fff', textShadow:'0 2px 8px rgba(0,0,0,.5)' }}>
        <h1 style={{ margin:0, fontSize:42 }}>{title}</h1>
        <p style={{ margin:'4px 0 0', fontSize:18 }}>{subtitle}</p>
      </div>
    </div>
  );
}